import { render, staticRenderFns } from "./PrognosePanel.vue?vue&type=template&id=a2a088d8&"
import script from "./PrognosePanel.vue?vue&type=script&lang=js&"
export * from "./PrognosePanel.vue?vue&type=script&lang=js&"
import style0 from "./PrognosePanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports